<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="d-flex flex-column flex-md-row">
            <div class="col-12 col-md-2 p-0 m-0">
              <bita-bootbutton
                v-if="!showForm"
                type="primary"
                title="راننده جدید"
                icon="fas fa-plus-square"
                class="w-100"
                @click.native="statusChangeModalCreate"
              />
            </div>
            <div class="col-12 col-md-2 p-0 m-0 mx-0 mx-md-2 my-2 my-md-0">
              <bita-bootbutton
                icon="fas fa-filter"
                type="success"
                class="w-100"
                title="فیلتر بیشتر"
                @click.native="toggleFilters"
              />
            </div>
          </div>
          <div style="text-align: center; margin-bottom: 20px;">
            <transition name="fade">
              <div v-show="showFilters">
                <hr />
                <bita-form ref="form">
                  <div slot="body">
                    <div class="row">
                      <bita-input
                        type="text"
                        name="search"
                        label="جستجو"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.search"
                        @change="(e) => driverSearch(e)"
                      />
                      <div>
                        <plate-number-inputes
                          ref="plate"
                          v-model="filters.number_plate"
                          @input="(e) => driverSearch(e)"
                        />
                      </div>
                      <bita-input
                        type="text"
                        name="national_code"
                        label="کدملی راننده"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.national_code"
                        @change="(e) => driverSearch(e)"
                      />
                      <!-- <bita-input
                        type="text"
                        name="search"
                        label="نام - نام خانوادگی"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.search"
                        @change="(e) => driverSearch(e)"
                        subtitle="جستجو بر اساس نام - نام خانوادگی"
                      />
                      <bita-input
                        type="text"
                        name="ssn_number"
                        label="شماره شناسنامه راننده"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.ssn_number"
                        @change="(e) => driverSearch(e)"
                      />
                      <bita-input
                        type="text"
                        name="mobile"
                        label="شماره موبایل"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.phone"
                        @change="(e) => driverSearch(e)"
                      />
                      <bita-input
                        type="text"
                        name="number_plate"
                        label="شماره پلاک خودرو"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.number_plate"
                        @change="(e) => driverSearch(e)"
                      /> -->
                      <bita-input
                        type="text"
                        name="city_code"
                        label="کد شهر"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.city_code"
                        @change="(e) => driverSearch(e)"
                      />
                      <bita-select
                        name="status"
                        label="وضعیت"
                        ref="statusDropDown"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="statuses"
                        data-text-field="name"
                        data-value-field="status_id"
                        v-model="filters.is_active"
                        @change="(e) => driverSearch(e)"
                      />
                      <bita-select
                        name="status"
                        label="نمایش رانندگان"
                        ref="comProfileDropDown"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="comProfiles"
                        data-text-field="name"
                        data-value-field="id"
                        v-model="filters.com_profile"
                        @change="(e) => driverSearch(e)"
                      />

                      <bita-select
                        name="status"
                        label="وضعیت پیامک رانندگان"
                        ref="statusSmsDropDown"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="notificationStatuses"
                        data-text-field="name"
                        data-value-field="id"
                        v-model="filters.sms_notification"
                        @change="(e) => driverSearch(e)"
                      />

                      <bita-select
                        type="vehicle_type_parent"
                        name="vehicle_type_parent"
                        label="دسته بندی نوع ماشین"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="vehicleTypeParent"
                        data-text-field="name"
                        data-value-field="id"
                        @change="getVehicleTypeChildren"
                      />
                      <Spinner
                        :is-loading="isLoadingVehicleType"
                        class-name="col-lg-2"
                        styleName="align-self: center;"
                      />

                      <bita-select
                        v-show="isLoadingVehicleType === false"
                        type="vehicle_type"
                        name="vehicle_type"
                        label="نوع ماشین"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="vehicleType"
                        data-text-field="name"
                        data-value-field="id"
                        v-model="filters.vehicle_type"
                        @change="(e) => driverSearch(e)"
                      />
                      <bita-select
                        type="roles"
                        name="roles"
                        label="نقش"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="roles"
                        data-text-field="fa_name"
                        data-value-field="id"
                        v-model="filters.role_id"
                        @change="(e) => driverSearch(e)"
                      />
                    </div>
                  </div>
                </bita-form>
              </div>
            </transition>
          </div>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
            :resizable="true"
            :page-size="pageSize"
            :current-page="currentPage"
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal-status
      modal-id="edit-modal2"
      title="ویرایش وضعیت"
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="updateFormStatus"
      @on-submit="handleEditStatus"
      @change="(e) => driverSearch(e)"
    />
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="updateForm"
      :props-vehicle-type-parent="vehicleTypeParent"
      :props-vehicle-type="vehicleType"
      modal-id="edit-modal"
      title="ویرایش راننده"
      @on-submit="handleEdit"
    />
    <form-modal
      ref="createModal"
      :isLoading="isLoadingModal"
      :props-data="createForm"
      :props-vehicle-type-parent="vehicleTypeParent"
      modal-id="create-modal"
      title="راننده جدید"
      @on-submit="handleCreate"
    />

    <view-modal
      modal-id="view-modal"
      title="مشخصات راننده"
      :props-data="updateForm"
      :props-vehicle-type-parent="vehicleTypeParent"
    />
    <priorities-modal
      modal-id="priorities-modal"
      :props-driver="propsDriver"
      :props-salons="propsSalons"
    />
    <map-modal ref="mapModal" title="موقعیت راننده" />
    <sms-form modal-id="sms-form" :props-driver="propsDriver" />
    <log-form ref="logForm" @load-data="loadData" />
    <activity-form ref="activityForm" @load-data="loadData" />
    <tickets ref="tickets" @load-data="loadData" />
    <wallet-report ref="walletReport" @load-data="loadData" />

    <!-- Actions -->
    <g-context-menu ref="contextMenu" #default="{items: driver}">
      <g-list>
        <g-list-item
          v-if="$acl.can('update', 'drivers') || isCarrier_test"
          title="ویرایش راننده"
          icon="fas fa-pen-square"
          @click="edit(driver)"
        />
        <g-list-item
          v-if="$acl.can('update', 'users')"
          title="تغییر وضعیت"
          icon="fas fa-lock"
          @click="status(driver)"
        />
        <g-list-item
          title="موقعیت راننده"
          icon="fas fa-map"
          @click="modalMap(driver)"
        />
        <g-list-item
          v-if="$acl.can('update', 'users')"
          title="تغییر وضعیت راننده"
          icon="fas fa-info"
          @click="editStatus(driver)"
        />
        <g-list-item
          v-if="$acl.can('log', 'drivers') || isCarrier_test"
          title="وضعیت بار های راننده"
          icon="fas fa-list"
          @click="cancleLog(driver)"
        />
        <g-list-item
          v-if="$acl.can('log', 'drivers')"
          title="گزارش فعالیت راننده"
          icon="fas fa-search"
          @click="activityForm(driver)"
        />
        <g-list-item
          v-if="$acl.can('log', 'drivers')"
          title="نوبت های راننده"
          icon="fas fa-check"
          @click="tickets(driver)"
        />
        <g-list-item
          v-if="$acl.can('log', 'drivers')"
          title="گزارش مالی"
          icon="fas fa-money-bill"
          @click="walletReport(driver)"
        />
        <g-list-item
          v-if="$acl.can('access', 'drivers') || isCarrier_test"
          title="رفع محدودیت رزرو راننده"
          icon="fas fa-user-times"
          @click="reemoveAccess(driver)"
        />
        <template v-if="driver.documents_file">
          <g-list-item
            title="دانلود اسناد"
            icon="fas fa-download"
            @click="handleDownloadDocuments(driver.documents_file)"
          />
        </template>
        <g-list-item
          v-if="$acl.can('view', 'salonPriorities')"
          title="اولویت راننده"
          icon="fas fa-sort"
          @click="priorities(driver)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('view', 'drivers-sms')"
          title="وضعیت پیامک راننده"
          icon="fas fa-sms"
          @click="sms(driver)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('delete', 'drivers')"
          title="حذف راننده"
          icon="fas fa-times"
          @click="deleteDriver(driver)"
        />
      </g-list>
    </g-context-menu>
  </div>
</template>
<script>
import DriversForm from "./From";
import DriversView from "./View";
import LogForm from "./LogForm.vue";
import PrioritiesForm from "./PrioritiesForm.vue";
import SmsForm from "./SmsForm.vue";
import Spinner from "../../../components/Spinner";
import RequestDetailForm from "./Form.vue";
import PlateNumberInputes from "@/components/PlateNumberInputs.vue";
import ActivityForm from "./components/ActivityForm.vue";
import MapModal from "./map";
import GContextMenu from "../../../components/GContextMenu.vue";
import GList from "../../../components/listItem/GList.vue";
import GListItem from "../../../components/listItem/GListItem.vue";
import Tickets from "./components/Tickets.vue";
import WalletOfDriver from "./components/WalletOfDriver.vue";

export default {
  components: {
    PlateNumberInputes,
    "form-modal-status": RequestDetailForm,
    "form-modal": DriversForm,
    "view-modal": DriversView,
    "priorities-modal": PrioritiesForm,
    "wallet-report": WalletOfDriver,
    SmsForm,
    LogForm,
    Spinner,
    ActivityForm,
    MapModal,
    GContextMenu,
    GList,
    GListItem,
    Tickets,
  },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت کاربران",
          link: "/",
        },
        {
          title: "مدیریت راننده ها",
          link: "/management/drivers",
          active: true,
        },
      ],
      pageSize: 0,
      currentPage: 0,
      isLoadingGrid: false,
      isLoadingModal: false,
      showForm: false,
      vehicleTypeParent: [],
      vehicleType: [],
      roles: [],
      createForm: {},
      dataState: null,
      updateFormStatus: {
        driver_id: 0,
      },
      isCarrier_test: false,
      updateForm: {},
      propsDriver: {},
      propsSalons: [],
      showFilters: false,
      isLoadingVehicleType: false,
      filters: {
        com_profile: 1,
      },
      statuses: [
        { id: 0, name: "غیرفعال" },
        { id: 1, name: "فعال" },
        { id: 2, name: "بلاک شده" },
        { id: 3, name: "ویرایش راننده" },
        { id: 4, name: "ایمپورت راننده" },
      ],
      notificationStatuses: [
        { id: 1, name: "فعال" },
        { id: 0, name: "غیرفعال" },
      ],
      comProfiles: [
        { id: 0, name: "همه رانندگان" },
        { id: 1, name: "اطلاعات تکمیل" },
        { id: 2, name: "اطلاعات تکمیل نشده" },
      ],
    };
  },
  computed: {
    gridColumns() {
      return [
        { title: "#", template: this.getTemplateID, width: "60px" },
        {
          field: "user.name",
          title: "نام",
          template: (e) => (e.user && e.user.name ? e.user.name : "-"),
          width: "100px",
        },
        {
          field: "user.family",
          title: "نام خانوادگی",
          template: (e) => (e.user && e.user.family ? e.user.family : "-"),
          width: "100px",
        },
        {
          field: "user.national_code",
          title: "کد ملی",
          template: (e) =>
            e.user && e.user.national_code ? e.user.national_code : "-",
          width: "100px",
        },
        {
          field: "car_smartnumber",
          title: "هوشمند ماشین",
          template: (e) => (e.car_smartnumber ? e.car_smartnumber : "-"),
          width: "100px",
        },
        {
          field: "user.phone",
          title: "شماره تماس",
          template: (e) => (e.user && e.user.phone ? e.user.phone : "-"),
          width: "100px",
        },
        {
          field: "number_plate",
          title: "شماره پلاک خودرو",
          template: (e) => (e.number_plate ? e.number_plate : "-"),
          width: "100px",
        },
        {
          field: "avg_rating",
          title: "امتیاز",
          template: (e) => (e.avg_rating ? e.avg_rating : "-"),
          width: "50px",
        },
        {
          field: "user.roles",
          title: "نقش",
          template: (e) => (e.user ? e.user.roles.map(item => item.fa_name).join(', ') : "-"),
          width: "100px",
        },
        {
          field: "user.balance.balance",
          title: "اعتبار (تومان)",
          template: (e) =>
            e.user.balance
              ? `${this.$thousandSeprator(e.user.balance.balance)}`
              : "-",
          width: "80px",
        },
        {
          field: "updated_at",
          title: "تاریخ بروزرسانی",
          template: (e) =>
            e.updated_at
              ? this.$getJalaliDateTimeToNewFormat(e.updated_at)
              : "",
          width: "100px",
        },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at
              ? this.$getJalaliDateTimeToNewFormat(e.created_at)
              : "",
          width: "100px",
        },
        {
          title: "وضعیت",
          template: (e) => (e.state_name ? this.statusText(e) : "-"),
          width: "60px",
        },
        {
          title: "عملیات",
          command: this.gridCommands(),
          width: 50,
        },
      ];
    },
  },
  mounted() {
    if (this.$acl.roles.find((e) => e === "carrier_test")) {
      this.isCarrier_test = true;
    }
    Promise.all([this.getVehicleType(0), this.getStatuses(), this.getRoles()]).then((res) => {
      let vehicleTypeParent = res[0].data;
      let statuses = res[1].data;
      let roles = res[2].data.filter(item => [1, 2, 5, 6, 28, 46].includes(item.id));
      this.vehicleTypeParent = vehicleTypeParent;
      this.statuses = statuses;

      this.roles = roles;
    });
  },

  methods: {
    getVehicleTypeChildren(e) {
      this.isLoadingVehicleType = true;
      this.$persistClient("get", `vehicle-types?filter[parent]=${e}`).then(
        (res) => {
          this.vehicleType = res.data;
          this.isLoadingVehicleType = false;
        }
      );
    },
    getRoles() {
      return this.$persistClient("get", "roles");
    },
    getTemplateID() {
      return this.$refs.grid.getTemplateLocal();
    },
    statusText(e) {
      return `<span class='label' style="color:white;background-color:${e.state_color}">${e.state_name}</span>`;
    },
    handleDownloadDocuments(documentsUrl) {
      window.open(documentsUrl, "_blank");
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      let baseUrl = `drivers/paginate?include=user,user.balance,user.roles&page=${this.currentPage}&page_size=${this.pageSize}`;
      let url = this.$makeQueryStringForSpatie(baseUrl, this.filters, "&");
      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    // statusChangeModalEdit() {
    //   this.showModalEdit = !this.showModalEdit;
    //   this.$toggleModal("#edit-modal");
    // },
    statusChangeModalCreate() {
      this.$toggleModal("#create-modal");
    },
    statusChangeModalEditStatus() {
      this.$toggleModal("#edit-modal2");
    },
    statusChangeModalView() {
      this.$toggleModal("#view-modal");
    },
    statusChangeModalEdit() {
      $("#edit-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalEdit2() {
      $("#edit-modal2")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    getStatuses() {
      return this.$persistClient("get", "states?type=driver");
    },
    editStatus(driver) {
      let requestDetail = driver;
      this.updateFormStatus = {
        id: requestDetail.user.id,
      };

      this.statusChangeModalEditStatus();
    },
    handleEditStatus(data) {
      this.dataState = data.state_id;
      this.$persistClient("patch", `users/${data.id}`, {
        is_active: this.dataState,
      })
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);
          this.loadData();
          this.isLoadingGrid = true;
          this.$refs.editModal.reset();
          this.$toggleModal("#edit-modal2");
        })
        .finally(() => {
          this.isLoadingGrid = true;
          this.$refs.editModal.reset();
          this.$toggleModal("#edit-modal2");
        });
    },
    gridCommands() {
      let commands = [];
      if (this.$acl.can("update", "users") || this.isCarrier_test) {
        commands.push({
          text: "view",
          click: this.showActions,
          template:
            "<a role='button' class='k-button k-button-icontext k-grid-view'><span class='fas fa-ellipsis-v' style='color:rgb(20 169 217)'></span></a>",
        });
      }
      return commands;
    },
    showActions(e) {
      e.originalEvent.stopPropagation();

      const request = this.$refs.grid.getSelectedGridRow(e);

      this.$refs.contextMenu.init(e.originalEvent, request);
    },
    reemoveAccess(driver) {
      let data = driver;
      this.$alert(
        "question",
        `آیا از رفع محدودیت رزرو این کاربر اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          if (data.user) {
            this.$persistClient("delete", `drivers/${data.id}/logs`)
              .then((res) => {
                this.$izitoast("success", "عملیات موفق", res.data.message);
                this.loadData();
              })
              .finally(() => {
                this.isLoadingGrid = false;
              });
          }
        }
      });
    },
    modalMap(driver) {
      if (driver) {
        let data = {};

        this.$persistClient("get", `drivers/${driver.user.id}/position`)
          .then((res) => {
            if (res.data.data) {
              data = {
                lat: res.data.data.latitude,
                lng: res.data.data.longitude,
                action: res.data.data.action,
                name: `${driver.user.name} ${driver.user.family}`,
                created_at: `${this.$getJalaliDateTimeToNewFormat(
                  res.data.data.created_at
                )}`,
              };

              this.$nextTick(() => {
                this.$refs.mapModal.createMap(data);
              });
            } else {
              this.$alert(
                "error",
                "خطا",
                `برای راننده (  ${driver.user.name} ${driver.user.family}  ) موقعیتی ثبت نشده !`
              );
            }
          })
          .finally(() => {
            this.isLoadingGrid = false;
          });
      } else {
        this.$refs.mapModal.createMap({});
      }
    },
    cancleLog(driver) {
      this.$refs.logForm.setInitialData(driver);
      this.$toggleModal("#log-form");
    },
    activityForm(driver) {
      this.$refs.activityForm.setInitialData(driver);
      this.$toggleModal("#activity-form");
    },
    tickets(driver) {
      this.$refs.tickets.setInitialData(driver);
      this.$toggleModal("#tickets");
    },
    walletReport(driver) {
      this.$refs.walletReport.setInitialData(driver);
      this.$toggleModal("#wallet-report");
    },
    status(driver) {
      let status = 1;

      if (driver.user.is_active == 1) {
        status = 0;
      }

      this.$alert(
        "question",
        `آیا از تغییر وضعیت این کاربر اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          if (driver.user) {
            this.$persistClient("patch", `users/${driver.user.id}`, {
              is_active: status,
            })
              .then((res) => {
                this.$izitoast("success", "عملیات موفق", res.data.message);
                this.loadData();
              })
              .finally(() => {
                this.isLoadingGrid = false;
              });
          }
        }
      });
    },
    edit(driver) {
      this.isLoadingModal = true;
      const _this = this;
      if (driver.vehicle_type && driver.vehicle_type.parent_id) {
        Promise.all([this.getVehicleType(driver.vehicle_type.parent_id)]).then(
          (res) => {
            this.vehicleType = res[0].data;
          }
        );
      }
      setTimeout(function() {
        _this.updateForm = {
          id: driver.id,
          name: driver.user.name,
          family: driver.user.family,
          national_code: driver.user.national_code,
          ssn_number: driver.user.ssn_number,
          phone: driver.user.phone,
          postal_code: driver.user.postal_code,
          address: driver.user.address,
          number_plate: driver.number_plate,
          car_smartnumber: driver.car_smartnumber,
          driver_smartnumber: driver.driver_smartnumber,
          certificate_number: driver.certificate_number,
          activation_code: driver.user.activation_code,
          vehicle_type_id: driver.vehicle_type_id,
          vehicle_type_parent_id: driver.vehicle_type
            ? driver.vehicle_type.parent_id
            : null,
        };
        _this.isLoadingModal = false;
      }, 300);
      this.statusChangeModalEdit();
    },
    info(e) {
      this.isLoadingModal = true;
      const _this = this;
      let driver = this.$refs.grid.getSelectedGridRow(e);
      if (driver.vehicle_type && driver.vehicle_type.parent_id) {
        Promise.all([this.getVehicleType(driver.vehicle_type.parent_id)]).then(
          (res) => {
            this.vehicleType = res[0].data;
          }
        );
      }
      setTimeout(function() {
        _this.updateForm = {
          id: driver.id,
          name: driver.user.name,
          family: driver.user.family,
          national_code: driver.user.national_code,
          ssn_number: driver.user.ssn_number,
          phone: driver.user.phone,
          postal_code: driver.user.postal_code,
          address: driver.user.address,
          number_plate: driver.number_plate,
          car_smartnumber: driver.car_smartnumber,
          driver_smartnumber: driver.driver_smartnumber,
          certificate_number: driver.certificate_number,
          vehicle_type_id: driver.vehicle_type_id,
          vehicle_type_parent_id: driver.vehicle_type
            ? driver.vehicle_type.parent_id
            : null,
        };
        _this.isLoadingModal = false;
      }, 300);
      this.statusChangeModalEdit2();
    },
    deleteDriver(driver) {
      this.$alert(
        "question",
        `آیا از حذف راننده ${driver.user.name} ${driver.user.family} اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `drivers/${driver.id}`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    view(e) {
      let driver = this.$refs.grid.getSelectedGridRow(e);

      this.getDriver(driver.id);

      this.statusChangeModalView();
    },
    handleCreate(data) {
      this.isLoadingModal = true;

      this.$persistClient("post", "drivers", data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.messages);

          this.createForm = {};

          this.loadData();
          this.$refs.createModal.reset();

          this.statusChangeModalCreate();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    handleEdit(data) {
      this.isLoadingModal = true;

      this.$persistClient("patch", `drivers/${data.id}`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.updateForm = {};

          this.loadData();
          this.$refs.editModal.reset();
          this.$toggleModal("#edit-modal");
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    getVehicleType(e) {
      return this.$persistClient("get", `vehicle-types?filter[parent]=${e}`);
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
      if (!this.showFilters) {
        this.filters = {
          com_profile: 1,
        };
        this.loadData();
        this.resetFilter();
      }
    },
    driverSearch: _.debounce(function() {
      this.loadData();
    }, 1000),
    resetFilter() {
      this.$refs.statusDropDown.emptyKendo();
    },
    priorities(driver) {
      this.propsDriver = driver;
      this.$toggleModal("#priorities-modal");
    },
    sms(driver) {
      this.propsDriver = driver;
      this.$toggleModal("#sms-form");
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
